import {
  CHANGE_AMS_SEGMENTS,
  CHANGE_INTERFACE_HEADER,
  CHANGE_LANGUAGE_ERROR,
  CHANGE_LAYOUT_DIMENSIONS,
  CHANGE_NAVIGATION,
  CHANGE_PAGE,
  CHANGE_PAGE_CALLBACK,
  CHANGE_USER_BALANCE,
  REDIRECT_USER_BONUSES,
  REQUEST_LOGIN_MODAL,
  SERVICE_RENDER_ERROR,
  UPDATE_NAVBAR_CALLBACK,
  USER_LOGIN,
  USER_LOGOUT,
} from '../constants';
import { RequestDataIds } from '../constants/ABA';
import { extractMetaInfo } from '../converter';
import { ChangePagePayload, State, UpdateNavbarCallback, UserBalanceChange } from '../types';

export * from './params';
export * from './modals';
export * from './updates';
export * from './redirects';

/**
 * type:event
 */
export const publishServiceRenderError = (payload: Error) => ({
  type: SERVICE_RENDER_ERROR,
  payload,
  error: true,
});
export const publishChangeLanguageError = (payload: Error) => ({
  type: CHANGE_LANGUAGE_ERROR,
  payload,
  error: true,
});
export const changePage = (payload: { id: string; event: ChangePagePayload }) => ({
  type: CHANGE_PAGE,
  payload,
});
export const changePageCallback = (payload: string, meta: ReturnType<typeof extractMetaInfo>) => ({
  type: CHANGE_PAGE_CALLBACK,
  payload,
  meta,
});
export const changeInterfaceHeader = (payload: boolean) => ({
  type: CHANGE_INTERFACE_HEADER,
  payload,
});
export const redirectUserBonuses = () => ({
  type: REDIRECT_USER_BONUSES,
});
export const userLogin = (payload: State[RequestDataIds.UserData] | { error: string | Error }) => ({
  type: USER_LOGIN,
  payload,
});
export const userLogout = () => ({
  type: USER_LOGOUT,
});

export const changeNavigation = (payload: string) => ({
  type: CHANGE_NAVIGATION,
  payload,
});

export const changeAmsSegments = (payload: State[RequestDataIds.AmsSegments]) => ({
  type: CHANGE_AMS_SEGMENTS,
  payload,
});

export const changeUserBalance = (payload: UserBalanceChange) => ({
  type: CHANGE_USER_BALANCE,
  payload,
});

export const updateNavbarCallback = (payload: UpdateNavbarCallback) => ({
  type: UPDATE_NAVBAR_CALLBACK,
  payload,
});

export const changeLayoutDimensions = (payload: State[RequestDataIds.LayoutDimensions]) => ({
  type: CHANGE_LAYOUT_DIMENSIONS,
  payload,
});

// TODO: deprecated action creator. Recommended to use requestLoginModal
export const publishRequestLoginModal = () => {
  console.warn('Action creator is deprecated. Recommended to use requestLoginModal action creator');
  return {
    type: REQUEST_LOGIN_MODAL,
  };
};
